import type { DataTableHeader } from '@/types/vuetify';

export function createToolUserDocumentsPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('toolUserDocuments.columns.date'),
            value: 'createdAt',
            key: 'createdAt',
            align: 'start',
            sortable: true,
            minWidth: 130,
        },
        {
            title: t('toolUserDocuments.columns.username'),
            value: 'toolUserName',
            key: 'toolUserName',
            align: 'start',
            sortable: true,
            minWidth: 100,
        },
        {
            title: t('toolUserDocuments.columns.documentType'),
            value: 'typeId',
            key: 'typeId',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 90,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('toolUserDocuments.columns.fileName'),
            value: 'originalFileName',
            key: 'originalFileName',
            align: 'start',
            sortable: false,
            minWidth: 160,
        },
        {
            title: t('toolUserDocuments.columns.file'),
            value: 'file',
            key: 'file',
            align: 'center',
            sortable: false,
            minWidth: 90,
        },
        {
            title: t('toolUserDocuments.columns.valid'),
            tooltip: t('toolUserDocuments.tooltips.valid'),
            value: 'isValid',
            key: 'isValid',
            align: 'center',
            sortable: false,
            minWidth: 70,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 48,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
